import './PartnerWithUsStep.scss';

interface PartnerWithUsStepProps {
  label: string;
  content: string;
}

function PartnerWithUsStep({ label, content }: PartnerWithUsStepProps) {
  return (
    <div className="step-container">
      <div className="label-container">
        <div className="label">{label}</div>
      </div>
      <div className="step-content">{content}</div>
    </div>
  );
}
export default PartnerWithUsStep;
